import { X, AlertTriangle } from 'lucide-react';
import { useDeleteProperty } from '../hooks/useDeleteProperty';

export const DeleteConfirmModal = (props) => {
  const { isOpen, onClose, property } = props;
  const { mutate: deleteProperty, isPending } = useDeleteProperty();

  if (!isOpen || !property) return null;

  const handleDelete = () => {
    deleteProperty(property._id, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card rounded-lg shadow-xl max-w-md w-full'>
        <div className='border-b border-border p-6 flex items-center justify-between'>
          <h2 className='text-xl font-bold text-foreground flex items-center gap-2'>
            <AlertTriangle className='text-red-500' size={24} />
            Confirm Delete
          </h2>
          <button
            onClick={onClose}
            className='p-2 hover:bg-muted rounded-lg transition-colors'
            disabled={isPending}
          >
            <X size={24} />
          </button>
        </div>

        <div className='p-6 space-y-4'>
          <p className='text-foreground'>Are you sure you want to delete this property?</p>

          <div className='bg-red-50 dark:bg-red-900/20 rounded-lg p-4 space-y-2'>
            <div>
              <p className='text-sm text-muted-foreground'>Property Location</p>
              <p className='font-medium text-foreground'>{property.propertyLocation}</p>
            </div>
            <div>
              <p className='text-sm text-muted-foreground'>City</p>
              <p className='font-medium text-foreground'>
                {property.address?.city}, {property.address?.state}
              </p>
            </div>
            <div>
              <p className='text-sm text-muted-foreground'>Price</p>
              <p className='font-medium text-foreground'>₹{property.propertyPrice?.toLocaleString()}</p>
            </div>
            <div>
              <p className='text-sm text-muted-foreground'>Owner</p>
              <p className='font-medium text-foreground'>{property.ownerName}</p>
            </div>
            <div>
              <p className='text-sm text-muted-foreground'>Seller</p>
              <p className='font-medium text-foreground'>
                {property.sellerId?.firstName} {property.sellerId?.lastName}
              </p>
            </div>
          </div>

          <div className='bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4'>
            <p className='text-sm text-yellow-800 dark:text-yellow-200'>
              <strong>Warning:</strong> This action cannot be undone. The property will be permanently removed from the
              system.
            </p>
          </div>

          <div className='flex gap-3 justify-end'>
            <button
              onClick={onClose}
              className='px-4 py-2 rounded-lg border border-border hover:bg-muted transition-colors'
              disabled={isPending}
            >
              Cancel
            </button>
            <button
              onClick={handleDelete}
              disabled={isPending}
              className='px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
            >
              {isPending ? 'Deleting...' : 'Delete Property'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
